import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { InlineInputGroup } from 'barnyard/components';
import TimeOperatorSelect from '~/app/corporate/core/containers/TimeOperatorSelect';


const InlineTimeOperator = (props) => {
  const {
    label,
    description,
    ...other
  } = props;

  return (
    <InlineInputGroup
      label={label}
      description={description}
      InputComponent={TimeOperatorSelect}
      placeholder='Select before or after'
      {...other}
    />
  );
};

InlineTimeOperator.propTypes = {
  label: PropTypes.string,
  description: PropTypes.string,
};

InlineTimeOperator.defaultProps = {
  label: 'Time Operator',
  description: 'Before or After'
};

export default memo(InlineTimeOperator);
